export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER';
export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED';
export const SET_IS_AUTHENTICATING = 'SET_IS_AUTHENTICATING';



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js